import {Gallery} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/gallery.types';
import {ProductTilePreferences} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_tile_preferences.types';
import {ProductTileV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_tile_v2.types';
import {ProductTileImage} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

interface InteractiveTileImagePreloadProps {
  onImageLoad?: () => void;
  tile: ProductTileV2;
  itemsPreferences?: ProductTilePreferences;
  'data-testid'?: string;
}

const getFirstImage = (gallery: Gallery) => {
  if (gallery.elements[0]?.type?.$case === 'image') {
    return gallery.elements[0].type.image.image;
  }
};

const getPreferredImage = (tile: ProductTileV2) => {
  return getFirstImage(tile.gallery)!;
};

export const InteractiveTileImagePreload = (
  props: InteractiveTileImagePreloadProps,
) => {
  const {onImageLoad, tile} = props;
  const preferredImage = getPreferredImage(tile);
  return (
    <InvisibleImageWrapper data-testid={props['data-testid']}>
      <ProductTileImage
        primaryImage={preferredImage}
        onLoad={onImageLoad}
        importance="high"
      />
    </InvisibleImageWrapper>
  );
};
const InvisibleImageWrapper = styled.div`
  display: none;
`;
